//
//
//
//
//
//
//
//
//

export default {
  name: 'SvgIcon',
  props: {
    // iconClass: {
    //   type: String,
    //   required: true
    // },
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default() {
        return 'md' // 'xs, sm, md, lg'
      }
    },
    color: {
      type: String,
      default() {
        return 'md' // 'xs, sm, md, lg'
      }
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    styleList() {
      const obj = {}
      if (this.color) {
        obj.color = this.color
      }
      return {
        color: this.color
      }
    }
  },
  methods: {
    svgClick(e) {
      this.$emit('click', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/m-common/components/SvgIcon/index.vue